import React, { useEffect, useState } from 'react';
import { Card, CardContent, TablePagination, Tabs, Tab } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { format } from 'date-fns';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import SafetyReportFilter from '../../components/SafetyReportFilter';
import CustomeSearch from '../../components/CustomSearch';
import { fetchSafetyReport, fetchSafetyProjects } from '../../redux/actions/safety';
import { getAllUsers } from '../../redux/actions/users';

const reportTypes = ['dailyForms', 'skyclimber', 'toolboxTalks'];
const reportLabels = ['Daily Forms', 'Skyclimber', 'Toolbox Talks'];

const breadcrumbs = [{ label: 'Safety Reports', isActive: true }];

const SafetyReports = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [filterState, setFilterState] = useState({
    fromDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    toDate: new Date(),
    userId: '',
    safetyProjectId: '',
    formId: ''
  });

  const dispatch = useDispatch();
  const { safetyReport } = useSelector(({ safety }) => safety);
  const { users } = useSelector(({ users: u }) => u);
  const { safetyProjects } = useSelector(({ safety }) => safety);

  const getFilterObj = (values) => {
    const data = {
      page: 1,
      pageSize: 100,
      userId: values.userId || undefined,
      dateFrom: format(values.fromDate, 'yyyy-MM-dd'),
      dateTo: format(values.toDate, 'yyyy-MM-dd')
    };
    if (tabIndex !== 2) {
      data.safetyProjectId = values.safetyProjectId || undefined;
      data.formId = values.formId || undefined;
    }
    return data;
  };

  useEffect(() => {
    dispatch(getAllUsers());
    dispatch(fetchSafetyProjects({ page: 1, pageSize: 200 }));
    dispatch(fetchSafetyReport(reportTypes[tabIndex], getFilterObj(filterState)));
  }, []);

  const loadReport = (tab, filters) => {
    dispatch(fetchSafetyReport(reportTypes[tab], getFilterObj(filters)));
  };

  const columnsForTab = () => {
    if (tabIndex === 2) {
      return [
        { name: 'userName', label: 'User' },
        { name: 'toolboxTitle', label: 'Toolbox Talk' },
        {
          name: 'submittedAt',
          label: 'Submitted At',
          options: {
            customBodyRender: (value) => (value ? format(new Date(value), 'MMM dd, yyyy HH:mm') : '')
          }
        }
      ];
    }
    return [
      { name: 'userName', label: 'User' },
      { name: 'projectName', label: 'Project' },
      { name: 'formTitle', label: 'Form' },
      {
        name: 'submittedAt',
        label: 'Submitted At',
        options: {
          customBodyRender: (value) => (value ? format(new Date(value), 'MMM dd, yyyy HH:mm') : '')
        }
      }
    ];
  };

  return (
    <PageContainer heading="SAFETY REPORTS" breadcrumbs={breadcrumbs}>
      <SafetyNav />
      <Card className="userlist">
        <Tabs
          value={tabIndex}
          onChange={(e, val) => {
            setTabIndex(val);
            loadReport(val, filterState);
          }}
          indicatorColor="primary"
          textColor="primary"
        >
          {reportLabels.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
        <SafetyReportFilter
          users={users}
          safetyProjects={safetyProjects?.data || []}
          showProjectFields={tabIndex !== 2}
          onFilter={(values) => {
            setFilterState(values);
            loadReport(tabIndex, values);
          }}
          initialFormState={filterState}
        />
        <CardContent>
          <MUIDataTable
            title={reportLabels[tabIndex]}
            data={safetyReport?.data || []}
            columns={columnsForTab()}
            options={{
              filterType: 'textField',
              responsive: 'standard',
              selectableRows: 'none',
              pagination: false,
              elevation: 0,
              customSearchRender: (searchText, handleSearch, hideSearch) => (
                <CustomeSearch handleSearch={handleSearch} hideSearch={hideSearch} />
              ),
              customFooter: () => (
                <tbody>
                  <tr>
                    <TablePagination
                      rowsPerPage={safetyReport?.pageSize || 100}
                      count={safetyReport?.count || 0}
                      page={safetyReport?.page ? safetyReport.page - 1 : 0}
                      onPageChange={(event, page) =>
                        dispatch(
                          fetchSafetyReport(reportTypes[tabIndex], {
                            ...getFilterObj(filterState),
                            page: page + 1,
                            pageSize: safetyReport?.pageSize || 100
                          })
                        )
                      }
                      onRowsPerPageChange={(event) =>
                        dispatch(
                          fetchSafetyReport(reportTypes[tabIndex], {
                            ...getFilterObj(filterState),
                            page: 1,
                            pageSize: event.target.value
                          })
                        )
                      }
                      rowsPerPageOptions={[10, 20, 40, 80, 100]}
                    />
                  </tr>
                </tbody>
              ),
              print: false,
              viewColumns: false
            }}
          />
        </CardContent>
      </Card>
    </PageContainer>
  );
};

export default SafetyReports;
